const CLIENT_COMMON_ERROR = {
  FAILED_TO_FETCH: 'common.errors.failedToFetch',
};

export default CLIENT_COMMON_ERROR;
